export const fluidType = {
  sectionTitle: 'clamp(2.25rem, 4.4vw, 4rem)',
  sentenceTitle: 'clamp(1.75rem, 2.75vw, 2.5rem)',
  pillar: 'clamp(1.125rem, 1.55vw, 1.75rem)',
  label: 'clamp(1.0625rem, 1.2vw, 1.1875rem)'
} as const

export const CARD_GAP = '0.625rem'
export const fromMobileFrame = (px: number) => `min(${((px / 440) * 100).toFixed(2)}vw, ${px}px)`
